export default {
  Interventional: 'rgb(207, 223, 255)',
  Observational: 'rgb(208, 240, 253)',
}
